module.exports = __webpack_public_path__ + "static/media/cultivo.7e6a2ee3.jpg";